import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '@webmate-web-core/shared/services/auth.service';
import {DeviceId, ProjectId, VideoRecordingId} from '@webmate-web-core/shared/types/ids';
import {VideoRecording} from '@webmate-web-core/shared/types/video';
import {Observable} from 'rxjs';
import {isDefined} from '@webmate-web-core/shared/utils/utils';
import {VideoMetaData} from '@webmate-web-core/shared/services/video-recording.service';

@Injectable({
    providedIn: 'root'
})
export class VideoRecordingRestapi {

    constructor(public OAuth2AuthService: AuthService, private http: HttpClient) {
    }

    getVideoRecording(videoId: VideoRecordingId): Observable<VideoRecording> {
        return this.http.get<VideoRecording>(`/videos/${videoId}/recording`);
    }

    getVideos(projectId: ProjectId): Observable<Array<VideoRecording>> {
        return this.http.get<VideoRecording[]>(`/videos/project/${projectId}`);
    }

    getVideosForDevice(deviceId: DeviceId, state?: string): Observable<Array<VideoRecording>> {
        let params = {};
        if (isDefined(state)) {
            params['state'] = state;
        }
        return this.http.get<VideoRecording[]>(`/videos/device/${deviceId}`, {params});
    }

    getVideo(videoId: VideoRecordingId): Observable<Blob> {
        return this.http.get(`/videos/${videoId}`, {responseType: 'blob'});
    }

    getVideoUrl(videoId: VideoRecordingId): string {
        return this.OAuth2AuthService.makeAuthorizedUrl("/videos/" + videoId);
    }

    deleteVideo(videoId: VideoRecordingId): Observable<any> {
        return this.http.delete(`/videos/${videoId}`);
    }

    storeVideo(projectId: ProjectId, videoBlob: Blob, videoMetaData: VideoMetaData): Observable<VideoRecordingId> {
        const metadata = {'name': videoMetaData.name, 'deviceId': videoMetaData.deviceId, 'duration': videoMetaData.duration};
        const uploadBlob = videoBlob.type === videoMetaData.type ? videoBlob : new Blob([videoBlob], {type: videoMetaData.type});
        return this.http.post<VideoRecordingId>(`/videos/${projectId}/blob`, uploadBlob, {
            headers: new HttpHeaders({
                'Content-Type': videoMetaData.type,
                'Metadata': JSON.stringify(metadata),
                'Video-Size': videoMetaData.size,
            })
        });
    }

    setVideoMetadata(videoId: VideoRecordingId, metadata: VideoMetaData): Observable<any> {
        return this.http.put(`/videos/${videoId}/metadata`, metadata);
    }

}
